import React, { useState, useEffect } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import close from "../../../../../../../../assets/close.svg";
import CustomSelect from '../../../../../../../../Util/CustomSelect/CustomSelect';
import { messages } from '../../../../../../../../messages';
import moment from 'moment';
import { TBD } from '../../../../../../../../Util/helper';
import axiosApi from '../../../../../../../../core/interceptor/interceptor';
import { config } from '../../../../../../../../config';
export default function PlayOffUpdate(props) {
  const { leagueId } = props;
  const [payload, setPayload] = useState({});
  const [playoffDateSet, setPlayoffDateSet ] = useState(false);
  const [oldPlayoff, setOldPlayoff ] = useState({});
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [matchup, setMatchup] = useState(props.matchup);
  const [isOpen, setIsOpen] = useState(false);
  const [leagueInfo, setLeagueInfo] = useState({});
  useEffect(() => {
    props.playOffBracket.date = props.playOffBracket.date && props.playOffBracket.date !== 'Invalid date' ? props.playOffBracket.date : null;
    setPayload((prev) => {
      const payld = {
        id: props?.playOffBracket?.id || null,
        league_id: props.leagueId ? +props.leagueId : 0,
        date: props.playOffBracket?.date && props.playOffBracket.show_tbd_date ? moment(props.playOffBracket?.date, 'MM/DD/YYYY').toDate() : null,
        time: props.playOffBracket?.time || null,
        location_id: props.playOffBracket?.location_id || null,
        field_id: props.playOffBracket?.field_id || null,
        team1_id: props.playOffBracket?.schedule?.team1_id || null,
        team2_id: props.playOffBracket?.schedule?.team2_id || null,
        team1_score: props.playOffBracket?.schedule?.team1_score || props.playOffBracket?.schedule?.team1_score == 0 ? props.playOffBracket?.schedule?.team1_score : null,
        team2_score: props.playOffBracket?.schedule?.team2_score || props.playOffBracket?.schedule?.team2_score == 0 ? props.playOffBracket?.schedule?.team2_score : null,
        group_name: props.playOffBracket?.name,
      }
      return payld;
    });
    if (props.playOffBracket?.location_id) {
      handleModalCloseResponse({ type: 'location_id', data: props.playOffBracket?.location_id }, true);
    }
    
    setOldPlayoff({
      date: props.playOffBracket?.date && props.playOffBracket.show_tbd_date ? moment(props.playOffBracket?.date, 'MM/DD/YYYY').toDate() : null,
      time: props.playOffBracket?.time,
      team1_score: props.playOffBracket?.schedule?.team1_score || props.playOffBracket?.schedule?.team1_score == 0 ? props.playOffBracket?.schedule?.team1_score : null,
      team2_score: props.playOffBracket?.schedule?.team2_score || props.playOffBracket?.schedule?.team2_score == 0 ? props.playOffBracket?.schedule?.team2_score : null,
      team1_id: props.playOffBracket?.schedule?.team1_id || null,
      team2_id: props.playOffBracket?.schedule?.team2_id || null,
      field_id: props.playOffBracket?.field_id || null,
      location_id: props.playOffBracket?.location_id || null,
    });
    //eslint-disable-next-line
  }, [props?.playOffBracket]);


  /*** closes modal *****/
  const closeModal = (resp = false) => {
    if (props.closeModal) {
      props.closeModal(resp);
    }
  }

  const onSelect = (data, type) => {
    if (data && data.title) {
      handleModalCloseResponse({ type, data: !['time'].includes(type) ? data.id : data.title });
    }
    if (data && !data.title) {
      handleModalCloseResponse({ type, data: data.id })
    }
  }

  const handleModalCloseResponse = (resp, locationChange) => {
    if (resp && resp.data) {
      setPayload((prevData) => {
        const payld = {
          ...prevData,
          [resp.type]: resp.data,
        }
        if (resp.type === 'location_id' && (prevData.location_id !== resp.data)) {
          payld.field_id = null;
        }
        if (['date','time'].includes(resp.type) && resp.data) {
          payld.show_tbd_date = true;
        }

        return payld;
      });
      if (locationChange) {
        const fields = [].concat.apply([], matchup.locationFields.map(x => x.fields)).filter(x => +x.parent_id === +resp.data);
        setMatchup(prev => {
          const filter_ = {
            ...prev,
            fields,
          };
          return filter_;
        });
      }
    } else if (resp.type === 'date' && !resp.data) {
      setPayload((prevData) => ({
          ...prevData,
          [resp.type]: resp.data,
          show_tbd_date: false,
      }));
    }
  }

  const teamName = (id) => {
    let name = '--';
    if (id && matchup && matchup.teamData) {
      name = matchup.teamData.find(x => +x.id === +id) ? matchup.teamData.find(x => +x.id === +id).name : '--';
    }
    return name;
  }

  const locationName = (id) => {
    let name = '';
    if (id && matchup && matchup.locationFields) {
      name = matchup.locationFields.find(x => +x.id === +id) ? matchup.locationFields.find(x => +x.id === +id).title : '';
    }
    return name;
  }

  const fieldName = (id, parent_id) => {
    let name = '';
    if (id && matchup && matchup.fields) {
      if (parent_id) {
        name = matchup.fields.find(x => (+x.id === +id && +x.parent_id === +parent_id)) ? matchup.fields.find(x => (+x.id === +id && +x.parent_id === +parent_id)).title : '';
      } else {
        name = matchup.fields.find(x => +x.id === +id) ? matchup.fields.find(x => +x.id === +id).title : '';
      }
    }
    return name;
  }

  const handleSubmit = (event, send_reschedule_message) => {
    event.preventDefault();
    setFormSubmitted(true);
    const data = { ...payload };
    if (
      !data.field_id ||
      !data.location_id ||
      !data.time) {
      return;
    }
    data.team1_score = data.team1_score || data.team1_score == 0 ? data.team1_score : null;
    data.team2_score = data.team2_score || data.team2_score ==0 ? data.team2_score : null;
    data.team1_name = teamName(payload.team1_id) || 'N/A';
    data.team2_name = teamName(payload.team2_id) || 'N/A';
    data.send_reschedule_message = send_reschedule_message || null;
    setFormSubmitted(false);
    if (props.type === 'playoff_active_league') {
      if (props.emit) {
        data.time = data.time === TBD.name ? null : moment(data.time, 'hh:mm A').format('HH:mm');
        data.date = moment(data.date).format('YYYY-MM-DD');
        props.emit(data);
      }
    }
  }
  const datePickerClick = (e) => {
    console.log(e);
    // console.log(e.target.classList.includes('clear-dt-btn'))
    if (e) {
      setIsOpen(!isOpen);
    }
  }

  useEffect(() => {
    if (leagueId) {
      axiosApi.get(`${config.apiUrl}/leagues/${leagueId}`).then((response) => {
        if (response.data?.data) {
          setLeagueInfo(response.data.data);
        }
      });
    }
  }, [leagueId]);

  useEffect(() => {
    if (payload.id && oldPlayoff.date) {
      if (
        !payload.team1_score && !payload.team2_score && payload.date && payload.time && moment(`${moment(payload.date).format('YYYY-MM-DD')} ${payload.time}`).isAfter(moment()) && 
        (!moment(payload.date).isSame(oldPlayoff.date) || 
        oldPlayoff.team1_id !== payload.team1_id || 
        oldPlayoff.team2_id !== payload.team2_id ||  
        payload.time !== oldPlayoff.time || 
        payload.field_id !== oldPlayoff.field_id ||
        payload.location_id !== oldPlayoff.location_id)
      ) {
        setPlayoffDateSet(true);
      } else {
        setPlayoffDateSet(false);
      }
    }
  }, [payload, oldPlayoff])
  return <>
    <div className="modal addMatchup">
      <div className="modal-header">
        <h2>{props?.title ? props?.title : 'Add Matchup'}</h2>
        {!props?.showSubTitle && <p>Enter matchup info</p>}
        <span className="close" onClick={closeModal}>
          <img src={close} alt='close-icon' />
        </span>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="modal-content addMatchup-Modal">
          <div className="input-field" >
            <label>Date</label>
            <DatePicker
              open={isOpen}
              isClearable={true}
              placeholderText={'MM/DD/YYYY'}
              minDate={new Date()}
              selected={payload.date}
              autoFocus={false}
              onChange={(date) => { handleModalCloseResponse({ type: 'date', data: date }); datePickerClick(); }}
              onClickOutside={datePickerClick}
              onInputClick= {() => setIsOpen(true)}
              clearButtonClassName={'clear-dt-btn'}
              onKeyDown={(e) => {
                e.preventDefault();
              }}
            />
            {!payload.date && formSubmitted && <span className="error">{messages.start_date_error}</span>}
          </div>
          <div className="select-blk">
            <CustomSelect
              required={true}
              uniqueKey={'time-level-key'}
              data={matchup?.times}
              label={'Time'}
              placeholder={TBD.value.includes(payload.time) ? TBD.name : payload.time}
              type={'time'}
              onSelect={onSelect}
              selector="title"
            />
            {!payload.time && formSubmitted && <span className="error">{messages.timeSlot_error}</span>}
          </div>
          <div className="select-blk">
            <CustomSelect
              required={true}
              uniqueKey={'location-level-key'}
              data={matchup?.locationFields}
              label={'Location'}
              placeholder={payload.location_id ? locationName(payload.location_id) : 'Select Location'}
              type={'location_id'}
              onSelect={(location) => handleModalCloseResponse({ type: 'location_id', data: location?.id }, true)}
              selector="title"
            />
            {!payload.location_id && formSubmitted && <span className="error">{messages.location_error}</span>}
          </div>
          <div className="select-blk">
            <CustomSelect
              required={true}
              uniqueKey={'field-level-key'}
              data={matchup?.fields}
              label={'Field'}
              placeholder={payload.field_id ? fieldName(payload.field_id, payload?.location_id) : 'Select Field'}
              type={'field_id'}
              onSelect={onSelect}
              selector="title"
            />
            {!payload.field_id && formSubmitted && <span className="error">{messages.field_error}</span>}
          </div>
          <div className="select-blk">
            <CustomSelect
              uniqueKey={'team1-level-key'}
              data={matchup?.teamData}
              label={'Team 1'}
              placeholder={payload.team1_id ? teamName(payload.team1_id) : 'Select Team 1'}
              type={'team1_id'}
              onSelect={onSelect}
              selector={props.type === 'playoff_active_league' ? 'name' : 'title'}
            />
            {!payload.team1_id && formSubmitted && <span className="error">{messages.team1_error}</span>}
          </div>
          <div className="select-blk">
            <CustomSelect
              uniqueKey={'team2-level-key'}
              data={matchup?.teamData}
              label={'Team 2'}
              placeholder={payload.team2_id ? teamName(payload.team2_id) : 'Select Team 2'}
              type={'team2_id'}
              onSelect={onSelect}
              selector={props.type === 'playoff_active_league' ? 'name' : 'title'}
            />
            {!payload.team1_id && formSubmitted && <span className="error">{messages.team2_error}</span>}
          </div>
          <div className="input-field">
            <label>Enter Score Team 1</label>
            <input type="number" placeholder="Enter Score Team 1" value={payload?.team1_score} onChange={(e) => setPayload((prev) => ({ ...prev, team1_score: e.target.value ? Number(e.target.value) : '' }))} />
          </div>
          <div className="input-field">
            <label>Enter Score Team 2</label>
            <input type="number" placeholder="Enter Score Team 2" value={payload?.team2_score} onChange={(e) => setPayload((prev) => ({ ...prev, team2_score: e.target.value ? Number(e.target.value) : '' }))} />
          </div>
        </div>
        <div className="modal-footer d-flex">
          <button className="cancel-btn" onClick={closeModal}>Cancel</button>
          <button type="submit" >Confirm</button>
          {
            leagueInfo?.enable_sms_reminder && leagueInfo?.enable_playoff_reminder && leagueInfo?.playoff_reschedule_message_template && playoffDateSet &&
            <button type="button" class="b-l-2" onClick={(e) => handleSubmit(e, true)} >Save & Send SMS</button>
          }
        </div>
      </form>
    </div>
  </>
}